import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Button } from 'antd';

/** 模块列表行（搜索筛选等非拖拽场景复用） */
export function ModuleMenuRowContent({ item, activeId, changeModules, editModule, deleteModule, showDragHandle, dragListeners }) {
    return (
        <div className={`module-menu-item ${item.id === activeId ? 'active' : ''}`} onClick={() => changeModules(item)}>
            <div className="menu-item-title-box">
                <span className="menu-item-name">{item.name}</span>
                {item.isShowHot === 1 && <span className="menu-item-name-tip hot">HOT</span>}
                {item.isShowTab === 0 && <span className="menu-item-name-tip hidden">隐</span>}
            </div>

            <div className="menu-item-option">
                <span className="anticon" onClick={e => editModule(e, item)}>
                    <i className="bi bi-pencil"></i>
                </span>
                {['rich_text', 'link', 'time_line'].includes(item.moduleType) ? (
                    <span className="anticon" onClick={e => deleteModule(e, item)}>
                        <i className="bi bi-trash"></i>
                    </span>
                ) : null}
                {showDragHandle ? (
                    <Button type="text" size="small" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} aria-label="模块排序" {...dragListeners}>
                        <i className="bi bi-grip-vertical"></i>
                    </Button>
                ) : null}
            </div>
        </div>
    );
}

/** 模块列表可排序行（@dnd-kit，替代 react-sortable-hoc，避免 findDOMNode 弃用警告） */
export default function SortableModuleRow({ item, activeId, changeModules, editModule, deleteModule }) {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: item.id,
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.65 : undefined,
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} className="sortable-module-row" role="listitem">
            <ModuleMenuRowContent item={item} activeId={activeId} changeModules={changeModules} editModule={editModule} deleteModule={deleteModule} showDragHandle dragListeners={listeners} />
        </div>
    );
}
